import React from 'react';
import { ReactSVG } from "react-svg";
import wlhLogo2 from "../../../assets/images/layout/wlh-header-logo-2.svg";

const AuthForm = ({ children }) => {
    return (
        <div className="bg-white text-black shadow-lg backdrop-blur-[15px] max-w-[600px] w-full min-h-screen md:min-h-0 md:h-auto rounded-[32px] mx-auto my-10 p-8">
            <div className="flex flex-col items-center px-14"> 
                <div className="self-center mt-18 -ml-20">
                    <ReactSVG src={wlhLogo2} />
                </div>
                {children}
            </div>
        </div>
    );
};

export default AuthForm;